import { getConfigModules } from 'src/config/sites/utils'

const routesPath = `routes/index`
export const siteRoutes = getConfigModules(routesPath)
export default siteRoutes?.default || []
